import { render } from "./UpdatePhone.vue?vue&type=template&id=75087526&ts=true"
import script from "./UpdatePhone.vue?vue&type=script&lang=ts"
export * from "./UpdatePhone.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__